import { createContext, useCallback, useContext, useState } from "react";
import { FileDrawer } from "@/components/files/FileDrawer";

const FilesContext = createContext(null);
export const useFiles = () => useContext(FilesContext);

export function FilesProvider({ children }) {
  const [openId, setOpenId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const bump = useCallback(() => setRefreshKey((k) => k + 1), []);
  const openFile = useCallback((id) => setOpenId(id), []);

  return (
    <FilesContext.Provider value={{ openFile, refreshKey, bump }}>
      {children}
      <FileDrawer fileId={openId} onClose={() => setOpenId(null)} onChanged={bump} />
    </FilesContext.Provider>
  );
}
